jQuery(function ($) { // wait for document ready
    var headerHeight = $('.page-header').outerHeight();
    var adminBarHeight = 0;
    if ($('#wpadminbar').length) {
        headerHeight += $('#wpadminbar').outerHeight();
        adminBarHeight += $('#wpadminbar').outerHeight();
    }
    var controller = new ScrollMagic.Controller({});
    var scenes = [];
    var doit;
    window.onresize = function(){
        clearTimeout(doit);
        doit = setTimeout(scrollSetup, 100);
    };
    setupCharitableTrustsPage();
    var curSize = '';
    function setupCharitableTrustsPage(force = false) {
        var windowWidth = $(window).width();
        var newSize = 'desktop';
        if (windowWidth <= 767) {
            newSize = 'mobile';
        }
        if (curSize == newSize && !force)
            return true;

        curSize = newSize;
        resetScrollMagic();
        var cookieVal = read_cookie('notice-dismissed');
        if (curSize == 'mobile') {

        }
        else if (curSize == 'desktop') {           

                  if ($('.injury-negligence-page').length) { 
                // child page
                // pin slide 1 throughout slides 2 and 3, so the heading stays still while the first 3 messages with the
                // white backgrounds scroll in and fade out
                scenes.push(
                    new ScrollMagic.Scene({
                            triggerHook: 'onLeave',
                            triggerElement: '#slide1',
                            duration: "185%",
                            offset: -1 * headerHeight
                        })
                        .setPin('#slide1')
                        .addTo(controller)
                );
                // toggle the active class to fade the text with the white background to fade in/out for slide 1
                scenes.push(
                    new ScrollMagic.Scene({
                            triggerHook: 'onEnter',
                            triggerElement: '#slide1',
                            duration: "185%",
                            offset: -1 * headerHeight
                        })
                        .setClassToggle($('#slide1')[0], "active")
                        // .addIndicators({name: 'Slide 1 Class'}) // add indicators (requires plugin)
                        .addTo(controller)
                );

      

                // pin slide 4 for a moment so it stays on the page briefly while scrolling
                scenes.push(new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide4',
                        duration: "100%",
                        offset: -1 * headerHeight
                    })
                    .setPin('#slide4', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));

                // pin slide 5 for a moment so it stays on the page briefly while scrolling
                scenes.push(new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide5',
                        duration: "100%",
                        offset: -1 * headerHeight
                    })
                    .setPin('#slide5', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));


                // set up some animations for the text and boxes to slide in from the left and right
                var slideTextFromLeftTween = new TimelineMax().from($('#slide4').find('.titles')[0], 0.5, {
                    left: -500,
                    opacity: 0,
                    top: 0,
                    ease: Linear.easeInOut
                }).to($('#slide4').find('.titles')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                var slideBoxFromRightTween = new TimelineMax().from($('#slide4').find('.box')[0], 0.5, {
                    left: 500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide4').find('.box')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                // make the text slide in from the left when entering slide 4
                scenes.push(new ScrollMagic.Scene({
                        triggerElement: '#slide4',
                        offset: -1 * (headerHeight),
                        triggerHook: 0.5,
                        duration: 0
                    })
                    .setTween(slideTextFromLeftTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the right when entering slide 4
                scenes.push(new ScrollMagic.Scene({
                        triggerElement: '#slide4',
                        offset: -1 * (headerHeight),
                        triggerHook: 0.5,
                        duration: 0
                    })
                    .setTween(slideBoxFromRightTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));


                // set up some animations for the text and boxes to slide in from the left and right
                var slideBoxFromLeftTween = new TimelineMax().from($('#slide5').find('.box')[0], 0.5, {
                    left: -500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide5').find('.box')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});
                var slideTextFromRightTween = new TimelineMax().from($('#slide5').find('.titles')[0], 0.5, {
                    left: 500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide5').find('.titles')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                // make the text slide in from the right when entering slide 5
                scenes.push(new ScrollMagic.Scene({
                        triggerElement: '#slide5',
                        offset: -1 * (headerHeight),
                        triggerHook: 0.5,
                        duration: 0
                    })
                    .setTween(slideTextFromRightTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the left when entering slide 5
                scenes.push(new ScrollMagic.Scene({
                        triggerElement: '#slide5',
                        offset: -1 * (headerHeight),
                        triggerHook: 0.5,
                        duration: 0
                    })
                    .setTween(slideBoxFromLeftTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                /*** START OF WATER MILL BACKGROUND **/

                // this is the background which is visible during slides 6 - 8 (the water mill)
                // slide background in
                var background = $('#background-2')[0];
                // add animations for the background to slide across and back as we scroll
                var backgroundSlideIn = TweenMax.to("#bg2-inner", 0.5, {
                    css: {'background-position-x': 0, opacity: 1, left: 0},
                    ease: Linear.easeInOut
                });
               

                // set up the background to slide in when reaching the element with the background (top of slide 6)
                scenes.push(new ScrollMagic.Scene({
                        triggerElement: background,
                        offset: -1 * (headerHeight),
                        triggerHook: 0.75,
                        duration: 0
                    })
                    .setTween(backgroundSlideIn)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // slide 6 also has the text and box sliding in from the left and right
                $("#slide6").find('h2').css('left','-25vw');
                $("#slide6").find('.box').css('left','25vw');

                var slideTextFromLeftTween2 = new TimelineMax()
                    .from($("#slide6").find('h2')[0], 0.5, {css: {'left': '-50vw', 'top': 0, opacity: 0}, ease: Linear.easeInOut})
                    .to($("#slide6").find('h2')[0], 0.5, {css: {'left': 0, 'top': 0, opacity: 1}, ease: Linear.easeInOut});

                var slideBoxFromRightTween2 = new TimelineMax()
                    .from($("#slide6").find('.box')[0], 0.5, {css: {'left': '50vw', 'top': 0, opacity: 0}, ease: Linear.easeInOut})
                    .to($("#slide6").find('.box')[0], 0.5, {css: {'left': 0, 'top': 0, opacity: 1}, ease: Linear.easeInOut});

          
                     // make the text slide in from the left when entering slide 6
                     scenes.push(new ScrollMagic.Scene({
                        triggerElement: background,
                        offset: -1 * (headerHeight),
                        triggerHook: 0.75,
                        duration: 0
                    })
                    .setTween(slideTextFromLeftTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the right when entering slide 6
                scenes.push(new ScrollMagic.Scene({
                        triggerElement: background,
                        offset: -1 * (headerHeight),
                        triggerHook: 0.75,
                        duration: 0
                    })
                    .setTween(slideBoxFromRightTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));


                // this pins the background for slides 6 - 8 so it stays at the same vertical position through these slides
                scenes.push(new ScrollMagic.Scene({
                        triggerElement: '#background-wrap',
                        offset: -1 * (headerHeight),
                        triggerHook: 'onLeave',
                        duration: '79%'
                    })
                    .setPin('#background-wrap', {pushFollowers: false})
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                    scenes.push(new ScrollMagic.Scene({
                        triggerElement: '.bg-3',
                        offset: -1 * (headerHeight),
                        triggerHook: 'onLeave',
                        duration: '79%'
                    })
                    .setPin('.bg-3', {pushFollowers: true})
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                    scenes.push(new ScrollMagic.Scene({
                        triggerElement: '.bg-4',
                        offset: -1 * (headerHeight),
                        triggerHook: 'onLeave',
                        duration: '79%'
                    })
                    .setPin('.bg-4', {pushFollowers: true})
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // this pins slide 6 so it stays in the same place for a moment while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide6',
                    duration: "100%",
                    offset: -1 * headerHeight
                })
                .setPin('#slide6', {pushFollowers: true})
                // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                .addTo(controller));



                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide12',
                        duration: "300%",
                        offset: -1 * headerHeight
                    })
                    .setClassToggle($('#slide12')[0], "active")
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );

                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide13',
                        duration: "300%",
                        offset: -1 * headerHeight
                    })
                    .setClassToggle($('#slide13')[0], "active")
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );



               
        
        
            }
        }
    }

    // Reset all scenes and controller
    function resetScrollMagic() {
        if (controller)
            controller.destroy('reset');
        controller = null;
        $.each(scenes,function(k,scene) {
            if (scenes[k])
            scenes[k].destroy('reset');
                scenes[k] = null;
        });
        scenes = [];
        controller = new ScrollMagic.Controller({});
    }


});